import {
  InitOptions,
  Source,
  Fit,
  Locale,
  Cta,
  Controls as ControlsType,
  StreamType,
  AlternativeLanguageSources,
  Autoplay,
  Colors,
  InitialValues,
  Responsive,
  Provider,
  ShortcutAction,
  PluginItem,
  CustomProvider,
  DvrSettings,
  LiveSettings,
  PlaybackMode,
  ControlsPosition,
  Control,
  SourceType,
  HlsProviderOptions,
  PosterFit,
  Logo,
} from '../../types/player';
import defaultOptions from '../../types/defaultOptions';
import Controls from './Controls';
import Sdk from '../Sdk';

export class Options {
  private options!: InitOptions;
  private sdk: Sdk;
  private _controls: Controls;

  constructor(sdk: Sdk) {
    this.sdk = sdk;
    this._controls = new Controls(this.sdk);
  }

  setOptions(options: InitOptions) {
    console.log(this.sdk.getUserAgent().getBrowser());

    this.options = this.mergeOptions(defaultOptions, options);
    this._controls.initControls(this.options.controls as ControlsType);
    this.processDVRControl();
  }

  processDVRControl() {
    return;
    /*TODO -> refacto NEED : do this in control component */
    /*if (this.options.source.playbackMode === PlaybackMode.DVR) {
      if (
        this.options.dvrSettings?.showControl === true &&
        !this._controls.retrieveControl(Control.LIVE_DVR_INDICATOR)
      ) {

        let position: string = ControlsPosition.BOTTOM_LEFT;
        if (this.options.dvrSettings.controlPosition !== undefined) {
          position = this.options.dvrSettings.controlPosition as string;
        }
        let controls: Control[] = this._controls.getData()?.[
          position
        ] as Control[];
        if (this.options.dvrSettings.inject === Inject.START)
          controls.push(Control.LIVE_DVR_INDICATOR);
        else controls.unshift(Control.LIVE_DVR_INDICATOR);
      }
    }*/
  }

  getOptions(): InitOptions {
    return this.options;
  }

  mergeOptions(defaultOptions: InitOptions, options: InitOptions) {
    if (
      options.controls &&
      (options.controls.topLeft ||
        options.controls.bottomLeft ||
        options.controls.topRight ||
        options.controls.bottomRight ||
        options.controls.subMenu ||
        options.controls.middle)
    ) {
      if (defaultOptions.controls && defaultOptions.controls.specificDevices) {
        defaultOptions.controls.specificDevices.forEach((specificDevice) => {
          delete specificDevice.controls.hideList;
          [
            'topLeft',
            'bottomLeft',
            'topRight',
            'bottomRight',
            'middle',
            'subMenu',
          ].forEach((controlZone) => {
            if (options.controls && options.controls[controlZone])
              delete specificDevice.controls[controlZone];
          });
        });
      }
    }

    return this.merge(JSON.parse(JSON.stringify(defaultOptions)), options);
  }

  merge(obj1: any, obj2: any): any {
    for (const key in obj2) {
      if (obj2.hasOwnProperty(key)) {
        if (
          typeof obj2[key] === 'object' &&
          obj2[key] !== null &&
          !Array.isArray(obj2[key])
        ) {
          if (!obj1[key]) {
            obj1[key] = {};
          }
          this.merge(obj1[key], obj2[key]);
        } else {
          obj1[key] = obj2[key];
        }
      }
    }
    return obj1;
  }

  getSource(): Source {
    return this.options.source as Source;
  }

  getPoster(): string | undefined {
    return this.options.poster;
  }

  getAutoplay(): Autoplay | undefined {
    return this.options.autoplay;
  }

  getMute(): boolean | undefined {
    return this.options.muted;
  }

  getFit(): Fit | undefined {
    return this.options.fit;
  }

  getRatio(): number {
    return this.options.ratio as number;
  }

  getPosterFit(): PosterFit {
    return this.options.posterFit as PosterFit;
  }

  getBgColor(): string | undefined {
    return this.options.bgColor;
  }

  getColors(): Colors | undefined {
    if (this.options.controlsColor) {
      return [
        {
          elements: [],
          value: this.options.controlsColor as string,
        },
      ] as Colors;
    }
    return this.options.colors;
  }

  isLoop(): boolean | undefined {
    return this.options.loop === true;
  }
  isRewind(): boolean | undefined {
    return this.options.rewind === true;
  }
  isBackground(): boolean | undefined {
    return this.options.background === true;
  }

  hasAudio(): boolean {
    return this.options.audio as boolean;
  }

  getWidth(): number | undefined {
    return this.options.width;
  }

  getHeight(): number | undefined {
    return this.options.height;
  }

  getControls(): Controls {
    return this._controls;
  }

  getInitialValues(): InitialValues {
    return this.options.initialValues as InitialValues;
  }

  getLocale(): Locale | undefined {
    return this.options.locale;
  }

  getTitle(): string | undefined {
    return this.options.title;
  }

  getLogo(): Logo {
    return this.options.logo as Logo;
  }

  getCta(): Cta | undefined {
    return this.options.cta;
  }

  /*getStreamType(): StreamType | undefined {
    return this.options..streamType;
  }*/

  getSourceType(): SourceType {
    return this.getSource().sourceType as SourceType;
  }

  getAlternativeLanguageSources(): AlternativeLanguageSources {
    return this.getSource()
      .alternativeLanguageSources as AlternativeLanguageSources;
  }

  getProviderOptions(providerName: Provider): object {
    if (
      !this.options.providersOptions ||
      !this.options.providersOptions[providerName]
    )
      return {};
    return this.options.providersOptions[providerName] as object;
  }

  getProviderHlsOptions(): HlsProviderOptions {
    return this.getProviderOptions(Provider.Hls) as HlsProviderOptions;
  }

  getProviderNativeOptions(providerName: Provider): object {
    if (
      !this.options.providersOptions ||
      !this.options.providersOptions[providerName + 'Native']
    )
      return {};
    return this.options.providersOptions[providerName + 'Native'] as object;
  }

  onBeforeInit(): void {
    if (this.options.onBeforeInit) {
      this.options.onBeforeInit(this.sdk);
    }
  }

  getJs(): string | undefined {
    return this.options.js;
  }

  getCss(): string | undefined {
    return this.options.css;
  }

  getResponsive(): Responsive | undefined {
    return this.options.responsive;
  }

  getShortCut(action: ShortcutAction) {
    return this.options.shortcuts?.find(
      (shortcut) => shortcut.action === action,
    );
  }

  getDvrSettings(): DvrSettings {
    return this.options.dvrSettings as DvrSettings;
  }

  getLiveSettings(): LiveSettings {
    return this.options.liveSettings as LiveSettings;
  }

  getPlugins(): PluginItem[] {
    return this.options.plugins || [];
  }

  hasCustomProvider(): boolean {
    return !!this.options.provider;
  }

  getProvider(): CustomProvider {
    return this.options.provider as CustomProvider;
  }
}
